const login = () => import(/* webpackPrefetch: true */ '@/views/public/index.vue')
const loginSidasi = () => import(/* webpackPrefetch: true */ '@/views/public/sidasi/login.vue')
const dashboardPublic = () => import(/* webpackPrefetch: true */ '@/views/public/dashboard-public/index.vue')
const routes = [
  {
    path: "/login",
    name: "Admin Login",
    component: login,
    meta: {
      title: "Admin Login",
      description: "Halaman masuk admin SIMPELBANG — Sistem Pelaporan Pembangunan Kabupaten Klaten.",
      robots: "noindex, nofollow"
    }
  },
  {
    path: "/login-sidasi",
    name: "Sidasi Login",
    component: loginSidasi,
    meta: {
      title: "Sidasi Login",
      description: "Halaman masuk Sidasi Kabupaten Klaten.",
      robots: "noindex, nofollow"
    }
  },
  {
    path: "/dashboard-public",
    name: "Dashboard Public",
    component: dashboardPublic,
    meta: {
      title: "Dashboard Publik",
      description: "Pantau realisasi fisik dan penyerapan keuangan program pembangunan seluruh Perangkat Daerah Kabupaten Klaten secara real-time melalui SIMPELBANG.",
      robots: "index, follow"
    }
  }
]
export default routes.map(route => {
  const meta = {
    all: false, 
    public: true,
    onlyLoggedOut: true,
    title: route.meta.title,
    description: route.meta.description,
    robots: route.meta.robots
  }
  return { ...route, meta }
})